/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDobbiesFooterCopyrightsViewProps } from './dobbies-footer-copyrights';

export default (props: IDobbiesFooterCopyrightsViewProps) => {
    const { moduleProps, contentProps, copyRightsText } = props;

    /* VSI Customization - START */
    /*  condition either to show or hide the header  */
    if (props.context.request.query!.onlyBody && props.context.request.query!.onlyBody === 'true') {
        return null;
    }
    /* VSI Customization - END */

    return (
        <Module {...moduleProps}>
            <Node {...contentProps}>{copyRightsText}</Node>
        </Module>
    );
};
